export function parseJwt (token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function checkTokenExpired(token: string){
  const parsedToken = parseJwt(token);
  return Date.now() / 1000 > parsedToken.exp;
}

export function getTokenFromStorage() {
  const localStorage = window.localStorage // inlocuit cu useLocalStorage hook
  const authKey = Object.keys(localStorage).find(k => k.includes('auth0') && !k.includes('@@user@@'))
  if (!authKey) {
    return
  }

  const cookie = JSON.parse(`${localStorage.getItem(authKey)}`);
  return cookie.body?.access_token;
}
